export default {
    approvals: {
        title: "Genehmigung",
        error: "Ein Fehler ist aufgetreten"
    },
    delegates: {
        title: "Delegierte",
        error: "Ein Fehler ist aufgetreten",
        noDelegates: "Keine Artikel",
        delegateDelete: "Der Delegierte wurde gelöscht",
        confirm: {
            delete: "Delegierten löschen?"
        },
        delegates: {
            email: "E-Mail",
            startDate: "Startdatum",
            endDate: "Enddatum",
        },
        buttons: {
            add: {
                text: "Delegierten hinzufügen"
            }
        }
    },
    employees: {
        title: "Meine Mitarbeiter",
        error: "Ein Fehler ist aufgetreten",
        empty: "Keine Mitarbeiter gefunden",
        users: {
            name: "Name",
            email: "E-Mail"
        },
        model: {
            search: {
                placeholder: "Suchen",
            }
        },
        cta: {
            orders: "Aufträge laden",
            download: "Bestellungen herunterladen",
            search: "Suchen"
        }
    }
}